import React from 'react'

export interface SwitchProps {
  checked: boolean
  onChange: (next: boolean) => void
  disabled?: boolean
  id?: string
  'aria-label'?: string
  'aria-labelledby'?: string
}

/**
 * 黑色實心開關：開＝墨色。軌道、圓鈕尺寸與「關」的顏色讀 `--toggle-*` 角色 token，
 * 網頁與 App 面各自的值寫在 kiao-tokens.css。
 */
export function Switch({
  checked,
  onChange,
  disabled,
  id,
  'aria-label': ariaLabel,
  'aria-labelledby': ariaLabelledby,
}: SwitchProps) {
  return (
    <label className="inline-flex h-[var(--toggle-h)] w-[var(--toggle-w)] cursor-pointer items-center rounded-full bg-[var(--toggle-off)] p-0.5 transition-colors has-[:checked]:bg-foreground has-[:disabled]:cursor-not-allowed has-[:disabled]:opacity-40 has-[:focus-visible]:outline-2 has-[:focus-visible]:outline-offset-2 has-[:focus-visible]:outline-[var(--focus-ring)]">
      <input
        type="checkbox"
        className="peer sr-only"
        role="switch"
        id={id}
        aria-label={ariaLabel}
        aria-labelledby={ariaLabelledby}
        checked={checked}
        disabled={disabled}
        onChange={(event) => {
          if (disabled) return
          onChange(event.target.checked)
        }}
      />
      <span
        className="size-[var(--toggle-knob)] rounded-full bg-background shadow-sm transition-transform peer-checked:translate-x-[calc(var(--toggle-w)-var(--toggle-knob)-var(--spacing))]"
        aria-hidden="true"
      />
    </label>
  )
}
